<template>
  <!-- BotInfo Information Card-->
  <div>
    <v-card-title primary-title>
      <span class='title'>Bots Information {{ botCount() }}</span>
    </v-card-title>
    <v-slide-y-transition mode='out-in'>
      <v-card-text class='pt-0'>
        <div class='pa-3 grey lighten-4'>
          <v-chip v-for='(pair, index) in pairs'
          :key='index'
          color="gray">
          {{pair.name}}
          </v-chip>
        </div>
        <div class='pa-3 grey lighten-4'>
          <v-layout row wrap>
            <!-- Start For loop -->
            <v-flex v-for='(pair, index) in pairs' :key='index' d-flex xs12 sm6 md4> 
              <v-expansion-panel expand :value='[true]'>
                <v-expansion-panel-content v-if='pair'> 
                    <v-card-title
                      primary-title
                      style='margin: 0 !important; padding: 0 !important'>
                      <v-btn
                        color='red'
                        style='color: white !important'
                        @click='deleteCard(index)'
                      >Delete</v-btn>
                      <h3
                        class='primary--text' 
                      >Bot #{{index+1}} | {{ pair.base }}{{ pair.quote }} {{ pair.xaccount }}</h3>
                    </v-card-title>
                    <v-card class='elevation-4 ma-2 mb-3'>
                      <v-card-text class='pt-0'>
                        <PairInfo
                        v-model="pairs[index]"
                        :basic=basic
                        :index=index
                        ></PairInfo>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-form>
              </v-expansion-panel>
            </v-flex>
            <!--end For Loop-->

            <!-- Start big add button -->
            <v-card
              class='elevation-4 ma-2 mb-3'
              style='cursor:pointer;background: #ffb100 !important; min-height:50px'
              @click='addNewCard()'
            >
              <v-card-text class='pt-0'>
                <div>
                  <v-flex xs12>
                    <div class='my-2'>
                      <h1>Add</h1>
                    </div>
                  </v-flex>
                </div>
              </v-card-text>
            </v-card>
            <!-- End big add button -->
          </v-layout>
        </div>
      </v-card-text>
    </v-slide-y-transition>
  </div>
</template>

<script>
import PairInfo from './PairInfo';
import SubAccountInfo from './SubAccountInfo';
import _ from 'lodash'

const pair = {
  type: 'bot',
  base: '',
  quote: '',
  name: 'default',
  xaccount: 'x',
  reportName: '',
  api: {
    full: {
      key: '',
      secret: ''
    },
    readonly: {
      key: '',
      secret: ''
    },
    report: {
      key: '',
      secret: ''
    }
  },
  isAddReport: true,
  isDefault: true,
  subaccount: {
    mainAccountId: '',
    subAccountId: '',
    subAccountName: ''
  }
};

export default {
  props: {
    basic: { type: Object, require: true }
  },
  data() {
    return {
      pairs: [_.cloneDeep(pair)],
      result: ''
    };
  },
  watch: {
    basic: { // the callback will be called immediately after the start of the observation
      immediate: true,
      deep: true,
      handler (val, oldVal) {
        pair.base = val.client
        this.pairs.forEach(_pair => {
          if (_pair.base === '') _pair.base = val.client
        });
      }
    }
  },
  components: {
    PairInfo,
    SubAccountInfo
  },
  methods: {
    addNewCard() {
      this.pairs.push(_.cloneDeep(pair));
    },
    deleteCard(id) {
      const newPairs = [...this.pairs]
      newPairs.splice(id, 1)
      this.pairs = newPairs
    },
    botCount() {
      return `( ${this.pairs.length} ${
        this.pairs.length <= 1 ? 'bot' : 'bots'
      } )`;
    }
  }
};
</script>